import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { type } from "../../features/filter/filterSlice";
function Sidebar() {
  // const {  jobType } = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  function handleTypeChange(jobType) {
    dispatch(type(jobType));
  }

  return (
    <div className="sidebar">
      <nav>
        <ul className="space-y-4">
          <li>
            <Link
              to="/"
              className="main-menu menu-active"
              id="lws-alljobs-menu"
              onClick={() => handleTypeChange("")}
            >
              <i className="fa-solid fa-briefcase"></i>
              <span> All Available Jobs</span>
            </Link>

            <ul className="space-y-6 lg:space-y-2 ">
              <li>
                <Link
                  className="sub-menu"
                  to="/"
                  id="lws-internship-menu"
                  onClick={() => handleTypeChange("Internship")}
                >
                  <i className="fa-solid fa-stop !text-[#FF5757] mr-1.5"></i>
                  Internship
                </Link>
              </li>
              <li>
                <Link
                  className="sub-menu"
                  to="/"
                  id="lws-fulltime-menu"
                  onClick={() => handleTypeChange("Full Time")}
                >
                  <i className="fa-solid fa-stop !text-[#FF8A00] mr-1.5"></i>
                  Full Time
                </Link>
              </li>
              <li>
                <Link
                  className="sub-menu"
                  to="/"
                  id="lws-remote-menu"
                  onClick={() => handleTypeChange("Remote")}
                >
                  <i className="fa-solid fa-stop !text-[#56E5C4] mr-1.5"></i>
                  Remote
                </Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/add" className="main-menu" id="lws-addJob-menu">
              <i className="fa-solid fa-file-circle-plus mr-1.5"></i>
              <span>Add NewJob</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Sidebar;
